var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isLoggedIn && _vm.isServerAvailable
        ? _c(
            "b-navbar",
            {
              style: _vm.styleObject,
              attrs: {
                toggleable: "md",
                type: "dark",
                variant: "dark",
                fixed: "top"
              }
            },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.sidebar-1",
                      modifiers: { "sidebar-1": true }
                    }
                  ],
                  staticClass: "mr-3",
                  attrs: { size: "sm" }
                },
                [_c("font-awesome-icon", { attrs: { icon: ["fas", "bars"] } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-brand",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.sidebar-1",
                      modifiers: { "sidebar-1": true }
                    }
                  ]
                },
                [_vm._v("PLATFORM")]
              ),
              _vm._v(" "),
              _c(
                "b-sidebar",
                {
                  attrs: {
                    id: "sidebar-1",
                    title: "Меню",
                    shadow: "",
                    "no-enforce-focus": "",
                    "no-close-on-route-change": "",
                    width: "240px"
                  },
                  model: {
                    value: _vm.isOpenMenu,
                    callback: function($$v) {
                      _vm.isOpenMenu = $$v
                    },
                    expression: "isOpenMenu"
                  }
                },
                [
                  _c(
                    "b-list-group",
                    {
                      staticClass: "menu text-small",
                      attrs: { id: "menu", flush: "" }
                    },
                    [
                      _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.name === "Home" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/home" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            staticStyle: { color: "darkorange" },
                            attrs: { icon: "home" }
                          }),
                          _vm._v("\n          Личный кабинет\n        ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasPermTask
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.name === "Tasks" &&
                                "active router-link-active",
                              attrs: {
                                to: { name: "Tasks" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkgreen" },
                                attrs: { icon: "tasks" }
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.tasks.title")) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermWorker
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/workers" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/workers" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkblue" },
                                attrs: { icon: "people-carry" }
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.workers.title")) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCustomer
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/customers" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/customers" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkred" },
                                attrs: { icon: "user-tie" }
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.customers.title")) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermLocation
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/locations" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/locations" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "green" },
                                attrs: { icon: "map-marked-alt" }
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.locations.title")) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermOrganization
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/organizations" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/organizations" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkred" },
                                attrs: { icon: "building" }
                              }),
                              _vm._v("\n          Организации\n        ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasPermStaff
                    ? _c(
                        "b-list-group",
                        {
                          staticClass: "menu text-small",
                          attrs: { flush: "" }
                        },
                        [
                          _c("hr", { staticClass: "m-0" }),
                          _vm._v(" "),
                          _vm.hasPermStaff
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/invoices" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/invoices" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkviolet" },
                                    attrs: { icon: "file-invoice-dollar" }
                                  }),
                                  _vm._v(
                                    "\n          Выставление счёта\n        "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermStaff
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path ===
                                      "/reconciliation_acts" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/reconciliation_acts" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darksalmon" },
                                    attrs: { icon: "file-contract" }
                                  }),
                                  _vm._v("\n          Акты сверки\n        ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermRecruit
                    ? _c(
                        "b-list-group",
                        {
                          staticClass: "menu text-small",
                          attrs: { flush: "" }
                        },
                        [
                          _c("hr", { staticClass: "m-0" }),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle:collapse-recruit",
                                  arg: "collapse-recruit"
                                }
                              ],
                              attrs: { variant: _vm.navVariant }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "royalblue" },
                                attrs: { icon: "people-arrows" }
                              }),
                              _vm._v("\n          Подбор\n          "),
                              _c(
                                "span",
                                { staticClass: "float-right when-open" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-up", size: "xs" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "float-right when-closed" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-right", size: "xs" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapse-recruit" } },
                            [
                              _vm.hasPermRecruitTask
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path === "/recruit_tasks" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/recruit_tasks" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [_vm._v("Заявки")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapse-recruit" } },
                            [
                              _vm.hasPermRecruitJobPosting
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path ===
                                          "/recruit_job_postings" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/recruit_job_postings" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [_vm._v("Объявления")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapse-recruit" } },
                            [
                              _vm.hasPermRecruitJobPosting
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path === "/responses" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/responses" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [_vm._v("Отклики")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapse-recruit" } },
                            [
                              _vm.hasPermLocationVacancy
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path ===
                                          "/recruit_location_vacancies" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: {
                                          path: "/recruit_location_vacancies"
                                        },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [_vm._v("Шаблоны вакансий")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermStaff
                    ? _c(
                        "b-list-group",
                        {
                          staticClass: "menu text-small",
                          attrs: { flush: "" }
                        },
                        [
                          _c("hr", { staticClass: "m-0" }),
                          _vm._v(" "),
                          _vm.hasPermStaff
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/staffs" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/staffs" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "black" },
                                    attrs: { icon: "id-card" }
                                  }),
                                  _vm._v("\n          Персонал\n        ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { staticClass: "menu text-small", attrs: { flush: "" } },
                    [
                      _c("hr", { staticClass: "m-0" }),
                      _vm._v(" "),
                      _vm.hasPermStatistic
                        ? _c(
                            "b-list-group-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle:collapse-statistics",
                                  arg: "collapse-statistics"
                                }
                              ],
                              attrs: { variant: _vm.navVariant }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkcyan" },
                                attrs: { icon: "chart-pie" }
                              }),
                              _vm._v("\n          Статистика\n          "),
                              _c(
                                "span",
                                { staticClass: "float-right when-open" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-up", size: "xs" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "float-right when-closed" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-right", size: "xs" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        { attrs: { id: "collapse-statistics" } },
                        [
                          _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.name === "ManagerStatistics" &&
                                "active router-link-active",
                              attrs: {
                                to: { name: "ManagerStatistics" },
                                variant: _vm.navVariant
                              }
                            },
                            [_vm._v("По менеджерам")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.name === "CustomerStatistics" &&
                                "active router-link-active",
                              attrs: {
                                to: { name: "CustomerStatistics" },
                                variant: _vm.navVariant
                              }
                            },
                            [_vm._v("По заказчикам")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasPermRegister
                        ? _c(
                            "b-list-group-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle:collapse-register",
                                  arg: "collapse-register"
                                }
                              ],
                              attrs: { variant: _vm.navVariant }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkmagenta" },
                                attrs: { icon: "chart-bar" }
                              }),
                              _vm._v("\n          Реестры\n          "),
                              _c(
                                "span",
                                { staticClass: "float-right when-open" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-up", size: "xs" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "float-right when-closed" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-right", size: "xs" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        { attrs: { id: "collapse-register" } },
                        [
                          _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.name === "Register" &&
                                "active router-link-active",
                              attrs: {
                                to: { name: "Register" },
                                variant: _vm.navVariant
                              }
                            },
                            [_vm._v("Общий")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasPermAnalytic
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/analytics" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/analytics" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkorange" },
                                attrs: { icon: "chart-line" }
                              }),
                              _vm._v("\n          Аналитика\n        ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermReport
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/reports" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/reports" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkslateblue" },
                                attrs: { icon: "table" }
                              }),
                              _vm._v("\n          Отчёты\n        ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { staticClass: "menu text-small", attrs: { flush: "" } },
                    [
                      _c("hr", { staticClass: "m-0" }),
                      _vm._v(" "),
                      _vm.hasPermUser
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/users" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/users" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "users" }
                              }),
                              _vm._v("\n          Пользователи\n        ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermRole
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/user_roles" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/user_roles" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "user-cog" }
                              }),
                              _vm._v("\n          Роли\n        ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalog
                        ? _c(
                            "b-list-group-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle:collapse-catalogs",
                                  arg: "collapse-catalogs"
                                }
                              ],
                              attrs: { variant: _vm.navVariant }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkgray" },
                                attrs: { icon: "list" }
                              }),
                              _vm._v("\n          Справочники\n          "),
                              _c(
                                "span",
                                { staticClass: "float-right when-open" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-up", size: "xs" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "float-right when-closed" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-right", size: "xs" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        { attrs: { id: "collapse-catalogs" } },
                        [
                          _vm.hasPermCatalogTown
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/town_catalogs" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/town_catalogs" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v("\n            Города\n          ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogCitizenship
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/citizenships" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/citizenships" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Гражданства\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogWorkType
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/work_type_catalogs" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/work_type_catalogs" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v("\n            Виды работ\n          ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogSource
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/marketing_sources" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/marketing_sources" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Маркетинговые источники\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogWorkerSource
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/worker_sources" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/worker_sources" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Источники исполнителей\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogWorkerStatus
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/worker_statuses" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/worker_statuses" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Статусы исполнителей\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogEmploymentCategory
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path ===
                                      "/employment_categories" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/employment_categories" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Категория занятости\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogDriverLicenseCategory
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path ===
                                      "/driver_license_categories" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/driver_license_categories" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Категории водительских прав\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogJobTitle
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/job_titles" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/job_titles" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v("\n            Должности\n          ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogLocationCostType
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path ===
                                      "/location_cost_types" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/location_cost_types" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Типы расходов объекта\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogLocationStatus
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/location_statuses" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/location_statuses" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Статусы объекта\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogWorkerCostType
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/worker_cost_types" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/worker_cost_types" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Типы расходов исполнителя\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogDepartment
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/departments" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/departments" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Подразделения\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogWorkService
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/work_services" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/work_services" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Услуги самозанятых\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogVacancy
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/vacancies" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/vacancies" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v("\n            Вакансии\n          ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogProjectStatus
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/project_statuses" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/project_statuses" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Статусы проектов\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogLeadStatus
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/lead_statuses" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/lead_statuses" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Статусы лидов\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogCustomerStatus
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/customer_statuses" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/customer_statuses" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Статусы заказчиков\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogLeadSource
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/lead_sources" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/lead_sources" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Источники лидов\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPermCatalogRecruitTag
                            ? _c(
                                "b-list-group-item",
                                {
                                  class:
                                    _vm.$route.path === "/recruit_tags" &&
                                    "active router-link-active",
                                  attrs: {
                                    to: { path: "/recruit_tags" },
                                    variant: _vm.navVariant
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "darkgrey" },
                                    attrs: { icon: "list" }
                                  }),
                                  _vm._v(
                                    "\n            Теги заявки на подбор\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: { right: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function() {
                              return [_c("em", [_vm._v(_vm._s(_vm.user.name))])]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        210705957
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("b-dropdown-item", { on: { click: _vm.logout } }, [
                        _vm._v(_vm._s(_vm.$t("message.login.logout")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : !_vm.isLoggedIn && !_vm.isServerAvailable
        ? _c("div", [_c("router-view")], 1)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navbar-height", style: _vm.styleObject },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _c("ErrorsModalWindow", {
        attrs: {
          offline: _vm.noConnectionError,
          "not-found": _vm.notFoundError,
          forbidden: _vm.forbiddenError
        },
        on: { hidden: _vm.resetErrorStates },
        model: {
          value: _vm.showErrorModal,
          callback: function($$v) {
            _vm.showErrorModal = $$v
          },
          expression: "showErrorModal"
        }
      }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "app" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 